import type { SalaryValue } from '../../../types';
import type { SalaryFilterRangeValue, SalaryFilterValue } from '../types';

const inRange = (value: number, range: SalaryFilterRangeValue) =>
  value >= range.from && value <= range.to;

const rangeOverlap = (a: SalaryValue, b: SalaryFilterRangeValue) =>
  inRange(a.minSalary, b) || inRange(a.maxSalary, b);

export const applySalaryFilter = (
  salary: SalaryValue,
  value: SalaryFilterValue
) => {
  if (salary.type === 'none') {
    return true;
  }

  if (value.type === 'custom') {
    return salary.type === 'custom' && value.value === salary.customSalary;
  }

  if (salary.type === 'custom') {
    return false;
  }

  const range = value.value as SalaryFilterRangeValue;

  if (range.currency !== salary.currency || range.period !== salary.period) {
    return false;
  }

  if (salary.type === 'range') {
    return rangeOverlap(salary, range);
  }

  return inRange(salary.amount, range);
};
